import React from 'react';
import Wrapper from './styles';

export default function UiPlaceholderIcon() {
    return <Wrapper />;
}
